<template>
    <div>

        <rkm-alert
            v-if="model && model.obitoEm"
            color="danger"
        >
            <span>Paciente em óbito.</span>
        </rkm-alert>

        <rkm-alert
            v-if="form && form.isResponsavel"
            color="info"
        >
            <span>Paciente é o responsável.</span>
        </rkm-alert>

        <rkm-alert
            v-if="!form.isUnidadeReferencia"
            color="warning"
        >
            <span>A Unidade de referência selecionada deixou de ser uma unidade referência. Atribua uma nova unidade.</span>
        </rkm-alert>

        <rkm-alert
            v-if="form && form.atualizacao"
            :color="form.diasAtrasados ? 'danger' : 'success'"
        >
            <span><strong>Última atualização:</strong> {{ form.atualizacao }}</span>
            <span v-if="form.diasAtrasados" class="pl-1">
                (cadastro desatualizado há <strong>{{ form.diasAtrasados }}</strong> {{ form.diasAtrasados > 1 ? 'dias' : 'dia'}})
            </span>
        </rkm-alert>

        <rkm-alert
            v-if="enderecoBloqueado"
            color="warning"
        >
            <span>O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o endereço na aba <strong>Endereço</strong> para liberar a edição das demais informações.</span>
        </rkm-alert>

        <rkm-tabs
            :disable-validation="readonly"
            :tab-refs="tabRefs"
            v-model="tabIndex"
        >
            <rkm-tab
                active
                :disabled="enderecoBloqueado"
                title="Dados do paciente"
            >
                <TabIdentificacao
                    :additionals="additionals"
                    :form="form"
                    :model="model"
                    ref="TabIdentificacao"
                />
            </rkm-tab>

            <rkm-tab
                :disabled="enderecoBloqueado"
                title="Documentações"
            >
                <TabDocumentos
                    ref="TabDocumentos"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab title="Endereço">
                <TabEndereco
                    ref="TabEndereco"
                    :form="form"
                    :model="model"
                    @limpar-informacoes-sociais="handleLimparInformacoesSociais"
                />
            </rkm-tab>

            <rkm-tab
                :disabled="enderecoBloqueado"
                title="Unidade/Equipe de referência"
            >
                <TabIdentificacaoSaude
                    ref="TabIdentificacaoSaude"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab
                :disabled="enderecoBloqueado"
                title="Questionário de saúde"
            >
                <TabQuestionarioSaude
                    ref="TabQuestionarioSaude"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab
                :disabled="enderecoBloqueado"
                title="Informações sociais"
            >
                <TabInformacoesSociais
                    ref="TabInformacoesSociais"
                    :form="form"
                    :model="model"
                    @mudanca-territorio="handleMudancaTerritorio"
                />
            </rkm-tab>

            <rkm-tab
                :disabled="enderecoBloqueado"
                title="Informações residenciais"
            >
                <TabInformacoesResidenciais
                    ref="TabInformacoesResidenciais"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>

            <rkm-tab
                :disabled="enderecoBloqueado"
                title="Composição familiar"
            >
                <TabComposicaoFamiliar
                    ref="TabComposicaoFamiliar"
                    :form="form"
                    :model="model"
                />
            </rkm-tab>
        </rkm-tabs>
    </div>
</template>

<script>
// Components.
import TabIdentificacao from './tabs/Identificacao'
import TabIdentificacaoSaude from './tabs/IdentificacaoSaude'
import TabEndereco from './tabs/Endereco'
import TabDocumentos from './tabs/Documentos'
import TabQuestionarioSaude from './tabs/QuestionarioSaude'
import TabInformacoesSociais from './tabs/InformacoesSociais'
import TabInformacoesResidenciais from './tabs/InformacoesResidenciais'
import TabComposicaoFamiliar from './tabs/ComposicaoFamiliar'

export default {
    components: {
        TabIdentificacao,
        TabDocumentos,
        TabEndereco,
        TabIdentificacaoSaude,
        TabQuestionarioSaude,
        TabInformacoesSociais,
        TabInformacoesResidenciais,
        TabComposicaoFamiliar
    },
    props: {
        additionals: { type: Object, required: true, default: () => ({}) },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        readonly: { type: Boolean, default: false },
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    computed: {
        enderecoBloqueado() {
            if (this.readonly || !this.additionals?.cadastroPacienteEnderecoDesatualizadoBloqueado) {

                return false
            }

            return !this.model?.cidadao?.domicilio?.endereco?.logradouro?.isOrigemBaseNacional
        },
    },
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
        handleLimparInformacoesSociais() {

            this.$refs.TabInformacoesSociais?.limparInformacoesSociais();
        },
        handleMudancaTerritorio() {
           this.$refs.TabIdentificacaoSaude?.limparResponsavel()
        }
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabIdentificacao,
            this.$refs.TabDocumentos,
            this.$refs.TabEndereco,
            this.$refs.TabIdentificacaoSaude,
            this.$refs.TabQuestionarioSaude,
            this.$refs.TabInformacoesSociais,
            this.$refs.TabInformacoesResidenciais,
            this.$refs.TabComposicaoFamiliar
        ]

        if (this.enderecoBloqueado) {

            this.tabIndex = this.tabRefs.indexOf(this.$refs.TabEndereco)
        }
    }
}
</script>